module.exports = __webpack_public_path__ + "static/media/logo2.3e6006fa.svg";